import { fetchFactory } from 'isotope-client'
import { Client } from './client.types'

export const getClients = () => fetchFactory<Client[]>('/clients')